import { Component, NgZone, Renderer2, ViewChild, Input, NgModule } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Plyr from 'plyr';
import * as Hls from 'hls.js';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IVideo() { }
if (false) {
    /** @type {?|undefined} */
    IVideo.prototype.crossorigin;
    /** @type {?|undefined} */
    IVideo.prototype.playsinline;
    /** @type {?|undefined} */
    IVideo.prototype.autoplay;
    /** @type {?|undefined} */
    IVideo.prototype.hideControls;
    /** @type {?|undefined} */
    IVideo.prototype.poster;
    /** @type {?|undefined} */
    IVideo.prototype.muted;
    /** @type {?|undefined} */
    IVideo.prototype.sources;
    /** @type {?|undefined} */
    IVideo.prototype.tracks;
    /** @type {?|undefined} */
    IVideo.prototype.src;
    /** @type {?|undefined} */
    IVideo.prototype.preload;
}
/**
 * @record
 */
function VideoSource() { }
if (false) {
    /** @type {?} */
    VideoSource.prototype.src;
    /** @type {?} */
    VideoSource.prototype.type;
    /** @type {?|undefined} */
    VideoSource.prototype.size;
}
/**
 * @record
 */
function VideoTrack() { }
if (false) {
    /** @type {?} */
    VideoTrack.prototype.kind;
    /** @type {?} */
    VideoTrack.prototype.label;
    /** @type {?} */
    VideoTrack.prototype.srclang;
    /** @type {?} */
    VideoTrack.prototype.src;
    /** @type {?|undefined} */
    VideoTrack.prototype.default;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VideoComponent = /** @class */ (function () {
    function VideoComponent(translate, ngZone, renderer) {
        var _this = this;
        this.translate = translate;
        this.ngZone = ngZone;
        this.renderer = renderer;
        this.options = {};
        this.translate
            .get([
            'ui.video.restart',
            'ui.video.rewind',
            'ui.video.play',
            'ui.video.pause',
            'ui.video.fastForward',
            'ui.video.seek',
            'ui.video.seekLabel',
            'ui.video.played',
            'ui.video.buffered',
            'ui.video.currentTime',
            'ui.video.duration',
            'ui.video.volume',
            'ui.video.mute',
            'ui.video.unmute',
            'ui.video.enableCaptions',
            'ui.video.disableCaptions',
            'ui.video.enterFullscreen',
            'ui.video.exitFullscreen',
            'ui.video.frameTitle',
            'ui.video.captions',
            'ui.video.settings',
            'ui.video.menuBack',
            'ui.video.speed',
            'ui.video.normal',
            'ui.video.quality',
            'ui.video.loop',
            'ui.video.start',
            'ui.video.end',
            'ui.video.all',
            'ui.video.reset',
            'ui.video.disabled',
            'ui.video.enabled',
            'ui.video.advertisement',
            'ui.video.qualityBadge.2160',
            'ui.video.qualityBadge.1440',
            'ui.video.qualityBadge.1080',
            'ui.video.qualityBadge.720',
            'ui.video.qualityBadge.576',
            'ui.video.qualityBadge.480'
        ])
            .subscribe((/**
         * @param {?} videoTxt
         * @return {?}
         */
        function (videoTxt) {
            /** @type {?} */
            var i18n = {
                restart: videoTxt['ui.video.restart'],
                rewind: videoTxt['ui.video.rewind'],
                play: videoTxt['ui.video.play'],
                pause: videoTxt['ui.video.pause'],
                fastForward: videoTxt['ui.video.fastForward'],
                seek: videoTxt['ui.video.seek'],
                seekLabel: videoTxt['ui.video.seekLabel'],
                played: videoTxt['ui.video.played'],
                buffered: videoTxt['ui.video.buffered'],
                currentTime: videoTxt['ui.video.currentTime'],
                duration: videoTxt['ui.video.duration'],
                volume: videoTxt['ui.video.volume'],
                mute: videoTxt['ui.video.mute'],
                unmute: videoTxt['ui.video.unmute'],
                enableCaptions: videoTxt['ui.video.enableCaptions'],
                disableCaptions: videoTxt['ui.video.disableCaptions'],
                enterFullscreen: videoTxt['ui.video.enterFullscreen'],
                exitFullscreen: videoTxt['ui.video.exitFullscreen'],
                frameTitle: videoTxt['ui.video.frameTitle'],
                captions: videoTxt['ui.video.captions'],
                settings: videoTxt['ui.video.settings'],
                menuBack: videoTxt['ui.video.menuBack'],
                speed: videoTxt['ui.video.speed'],
                normal: videoTxt['ui.video.normal'],
                quality: videoTxt['ui.video.quality'],
                loop: videoTxt['ui.video.loop'],
                start: videoTxt['ui.video.start'],
                end: videoTxt['ui.video.end'],
                all: videoTxt['ui.video.all'],
                reset: videoTxt['ui.video.reset'],
                disabled: videoTxt['ui.video.disabled'],
                enabled: videoTxt['ui.video.enabled'],
                qualityBadge: {
                    2160: videoTxt['ui.video.qualityBadge.2160'],
                    1440: videoTxt['ui.video.qualityBadge.1440'],
                    1080: videoTxt['ui.video.qualityBadge.1080'],
                    720: videoTxt['ui.video.qualityBadge.720'],
                    576: videoTxt['ui.video.qualityBadge.576'],
                    480: videoTxt['ui.video.qualityBadge.480']
                }
            };
            _this.options.i18n = i18n;
        }));
    }
    /**
     * @return {?}
     */
    VideoComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.video.autoplay = !!this.video.autoplay;
        this.video.muted = !!this.video.muted;
    };
    /**
     * @return {?}
     */
    VideoComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var options = Object.assign({}, this.options);
        if (this.video.hideControls) {
            options.controls = false;
        }
        if (this.video && this.playerEl) {
            this.player = new Plyr(this.playerEl.nativeElement, options);
        }
        if (this.video.src && this.video.src.indexOf('.m3u8') > -1) {
            this.hls = new Hls({ autoStartLoad: this.video.autoplay });
            this.hls.loadSource(this.video.src);
            this.hls.attachMedia(this.playerEl.nativeElement);
            this.player.on('play', (/**
             * @return {?}
             */
            function () {
                _this.hls.startLoad();
            }));
        }
    };
    /**
     * @return {?}
     */
    VideoComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.player) {
            this.player.destroy();
        }
        if (this.hls) {
            this.hls.destroy();
        }
    };
    VideoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-video',
                    template: "\n    <ng-container *ngIf=\"video\">\n      <div class=\"container\">\n        <video #videoPlayer\n          [controls]=\"!video.hideControls\"\n          [attr.preload]=\"video.preload? video.preload: 'none'\"\n          [attr.crossorigin]=\"video.crossorigin\"\n          [attr.playsinline]=\"video.playsinline\"\n          [poster]=\"video.poster\"\n          [autoplay]=\"video.autoplay\"\n          [muted]=\"video.muted\" >\n          <ng-container *ngFor=\"let source of video.sources\">\n            <!-- video files -->\n            <source [attr.src]=\"source.src\" [attr.type]=\"source.type\" [attr.size]=\"source.size\" />\n          </ng-container>\n\n          <ng-container *ngFor=\"let track of video.tracks\">\n            <!-- Caption files -->\n            <track [attr.kind]=\"track.kind\" [attr.label]=\"track.label\" [attr.srclang]=\"track.srclang\" [attr.src]=\"track.src\" [attr.default]=\"track.default\" />\n          </ng-container>\n        </video>\n      </div>\n    </ng-container>\n  "
                }] }
    ];
    /** @nocollapse */
    VideoComponent.ctorParameters = function () { return [
        { type: TranslateService },
        { type: NgZone },
        { type: Renderer2 }
    ]; };
    VideoComponent.propDecorators = {
        playerEl: [{ type: ViewChild, args: ['videoPlayer', { static: false },] }],
        video: [{ type: Input }]
    };
    return VideoComponent;
}());
if (false) {
    /** @type {?} */
    VideoComponent.prototype.playerEl;
    /** @type {?} */
    VideoComponent.prototype.video;
    /** @type {?} */
    VideoComponent.prototype.player;
    /** @type {?} */
    VideoComponent.prototype.sources;
    /**
     * @type {?}
     * @private
     */
    VideoComponent.prototype.options;
    /** @type {?} */
    VideoComponent.prototype.hls;
    /**
     * @type {?}
     * @private
     */
    VideoComponent.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    VideoComponent.prototype.ngZone;
    /**
     * @type {?}
     * @private
     */
    VideoComponent.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UIVideoNgModule = /** @class */ (function () {
    function UIVideoNgModule() {
    }
    UIVideoNgModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [VideoComponent],
                    exports: [VideoComponent]
                },] }
    ];
    return UIVideoNgModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { UIVideoNgModule, VideoComponent };
//# sourceMappingURL=inflight-ui-video-ng.js.map
